/* Auto-generated by scripts/generate-tailwind-config.js — DO NOT EDIT */
/* eslint-disable */
// @ts-nocheck
export const tailwindConfig = {
    "breakpoints": {
        "print": "print",
        "sm": "(min-width: 600px)",
        "md": "(min-width: 960px)",
        "lg": "(min-width: 1280px)",
        "xl": "(min-width: 1440px)"
    },
    "themes": {
        "default": {
            "primary": "#4f46e5",
            "accent": "#1e293b",
            "warn": "#dc2626"
        },
        "brand": {
            "primary": "#cd7f32",
            "accent": "#1e293b",
            "warn": "#dc2626"
        },
        "indigo": {
            "primary": "#0d9488",
            "accent": "#1e293b",
            "warn": "#dc2626"
        },
        "rose": {
            "primary": "#f43f5e",
            "accent": "#1e293b",
            "warn": "#dc2626"
        },
        "purple": {
            "primary": "#9333ea",
            "accent": "#1e293b",
            "warn": "#dc2626"
        },
        "amber": {
            "primary": "#f59e0b",
            "accent": "#1e293b",
            "warn": "#dc2626"
        },
        "asse": {
            "primary": "#cd7f32",
            "accent": "#cd7f32",
            "warn": "#dc2626"
        }
    }
};
